import { render, staticRenderFns } from "./LabelFunMessage.vue?vue&type=template&id=d60b4a32&scoped=true&"
import script from "./LabelFunMessage.vue?vue&type=script&lang=js&"
export * from "./LabelFunMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60b4a32",
  null
  
)

export default component.exports